import React, {useState, useCallback} from "react";
import { withLocalize } from "react-localize-redux";
import { useRouteMatch } from "react-router-dom";

import "./style.scss";
import useTabTopics from "../../../../useHook/useTabTopics";
import Tabs from "../../../../components/Tabs";

function TabPlayer() {
    let { url } = useRouteMatch();

    const {menus, menuHelper, onUpdateTitleTopic, onCreateTopic} = useTabTopics('player',[
        { name: '基本情報', to: url, exact: true },
        { name: '条件別成績', to: `${url}/performance-by-condition`, exact: false },
        { name: 'Game Logs', to: `${url}/game-logs`, exact: false },
        { name: '年度別成績', to: `${url}/performance-by-year`, exact: false },
    ]);

    const [editIndex, setEditIndex] = useState(-1);

    const onSaveTitle = useCallback(async (item, index) => {
        setEditIndex(-1);
        await onUpdateTitleTopic({
            topicId: item.id,
            title: item.name,
        });
        setEditIndex(-1);
        menuHelper.updateAt(index, item)
    }, []);

    const onUpdateTitle = useCallback((index) => {
        setEditIndex(index)
    }, []);

    const onAddFreeTopic = useCallback((useDefault) => {
        onCreateTopic(useDefault);
    }, []);


    return (
        <Tabs menuList={menus}
              popupList={[
                  { value: 0, name: 'Free Topicsを追加'},
                  { value: 1, name: 'Player Topicsを追加'},
              ]}
              editIndex={editIndex}
              onAddFreeTopic={onAddFreeTopic}
              onSaveTitle={onSaveTitle}
              onUpdateTitle={onUpdateTitle}
        />
    );
}

export default withLocalize(TabPlayer);